import {initializeApp} from "firebase/app";
import {isSupported, getMessaging} from "firebase/messaging";
import Vue from "vue";

// @ts-ignore
import firebaseConfig from "@/firebaseConfig.json";

isSupported()
    .then(supported => {

        if (!supported) return;

        const firebaseApp = initializeApp(firebaseConfig);

        Vue.prototype.$messaging = getMessaging(firebaseApp);

        registerServiceWorker();
    });

const registerServiceWorker = () => {

    const options = {
        scope: "/"
    };

    navigator.serviceWorker.register('/firebase-messaging-sw.js', options);
}